import { alpha } from '@mui/material/styles';

import { grey } from './grey';

export const text = {
  primary: alpha(grey[900], 0.87),
  secondary: alpha(grey[900], 0.54),
  disabled: alpha(grey[900], 0.38),
  hint: alpha(grey[900], 0.38),
} as const;
